<template>
  <div class="head blink1">
    彩霸王
    <img src="../assets/img2/dujianeimu.png" alt="" />
  </div>
  <div class="navs">
    <div v-for="(item, index) in navs" :key="index" @click="onClick(item)">
      {{ item.name }}
    </div>
  </div>
</template>

<script setup>
import typeTableIcon from "@/assets/img/typeTableIcon.png";
import logo from "@/assets/img/logo.png";
import { useRouter } from "vue-router";
const router = useRouter();

const getUrl = (iconName) => {
  return new URL(`../assets/img2/${iconName}.png`, import.meta.url).href;
};

function onClick(item) {
  if (item.url) {
    window.open(item.url, "_blank");
  }
}

const navs = [
  { name: "精华帖子", icon: getUrl("1") },
  { name: "高手帖子", icon: getUrl("2") },
  {
    name: "无敌四肖",
    icon: getUrl("3"),
    url: "https://kaijianglishi.ab0149.xyz/",
  },
  { name: "精选24码", icon: getUrl("4") },
  { name: "生肖属性", icon: getUrl("5") },
  {
    name: "七肖七码",
    icon: getUrl("6"),
    url: "https://kaijianglishi.ab0149.xyz/",
  },
  { name: "澳门图库", icon: getUrl("7") },
];
</script>

<style lang="scss" scoped>
.head {
  width: 100vw;
  // display: flex;
  // align-items: center;
  // justify-content: space-between;
  padding: 6px 10px;
  // background-color: #2ab0f2;
  background: #3ed569;
  display: flex;
  flex: 1;
  justify-content: space-between;
  color: #0f570d;
  font-size: 30px !important;
  font-weight: bold;
  line-height: 40px;
}
.navs {
  display: flex;
  grid-template-columns: repeat(4, 1fr);
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
  background-color: #fff;
  grid-gap: 12px;
  background: #3ed569;
  border-top: 2px solid #0f570d;
  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    color: #333;
    color: #fff;
    cursor: pointer;
    img {
      margin-bottom: 6px;
      width: 50%;
    }
    &:hover {
      color: #f13131;
    }
  }
}
</style>